import { Dropdown } from '@/components/dropdown'
import { MonthsEnum } from '@/types'
import { Box, Stack } from '@mui/material'
import { getYear } from 'date-fns'
import { useSearchParams } from 'react-router-dom'

const CURRENT_YEAR = getYear(new Date())

const YEARS_OPTIONS = [
  { label: 'Todos os anos', value: 'all' },
  { label: String(CURRENT_YEAR + 1), value: CURRENT_YEAR + 1 },
  { label: String(CURRENT_YEAR), value: CURRENT_YEAR },
  { label: String(CURRENT_YEAR - 1), value: CURRENT_YEAR - 1 },
  { label: String(CURRENT_YEAR - 2), value: CURRENT_YEAR - 2 },
]

const MONTH_OPTIONS = [
  { label: 'Todos os meses', value: 'all' },
  ...Object.entries(MonthsEnum)
    .map(([key, value]) => ({
      label: value as string,
      value: key,
    }))
    .slice(0, 12)
    .sort((a, b) => Number(b.value) - Number(a.value)),
]

const PAID_FILTER_OPTIONS = [
  { label: 'Todos', value: 'all' },
  { label: 'Pendente', value: 'false' },
  { label: 'Pago', value: 'true' },
]

type TaxGuidesFiltersProps = {
  month: string
  paid: string
  year: string
}

export function TaxGuidesFilters({ month, paid, year }: TaxGuidesFiltersProps) {
  const [searchParams, setSearchParams] = useSearchParams()

  const monthLabel =
    month === 'all'
      ? 'Todos os meses'
      : (MonthsEnum[Number(month)] ?? 'Todos os meses')
  const yearLabel = year === 'all' ? 'Todos os anos' : year
  const paidLabel =
    PAID_FILTER_OPTIONS.find((option) => option.value === paid)?.label ??
    'Todos'

  const handleFilter = (query: string, value: string | number) => {
    if (value === 'all' && query !== 'paid') {
      searchParams.delete(query)
    } else {
      searchParams.set(query, value.toString())
    }

    setSearchParams(searchParams)
  }

  return (
    <Stack direction="row" mb={2} alignItems="center" gap={1} flexWrap="wrap">
      <Dropdown
        label={monthLabel}
        options={MONTH_OPTIONS}
        onSelect={(value) => handleFilter('m', value)}
      />

      <Dropdown
        label={yearLabel}
        options={YEARS_OPTIONS}
        onSelect={(value) => handleFilter('y', value)}
      />

      <Box flex={1} />

      <Dropdown
        label={paidLabel}
        options={PAID_FILTER_OPTIONS}
        onSelect={(value) => handleFilter('paid', value)}
      />
    </Stack>
  )
}
